var internetPublishOption = (window.HandbookConfiguration && window.HandbookConfiguration.InternetPublishOption == 'True') ? true : false;
var publishedVersion = (window.HandbookConfiguration && window.HandbookConfiguration.PublishedVersion == 'True') ? true : false;
var internetColumnVisible = (window.HandbookConfiguration && window.HandbookConfiguration.InternetColumnVisible == 'True') ? true : false;
var gridSettingKeys = {
    commonVisibilitySettings: 'ColumnVisiblitySettings',
    readingListVisibilitySettings: 'ReadingListVisibilitySettings'
}

function ColumnItem() {
    this.visible = false;
    this.width = '';
    this.minWidth = 0;
};

var commonGridSetting = {
    title: new ColumnItem(),
    documentType: new ColumnItem(),
    chapter: new ColumnItem(),
    documentId: new ColumnItem(),
    readingList: new ColumnItem(),
    isConfirmed: new ColumnItem(),
    location: new ColumnItem(),
    version: new ColumnItem(),
    readCount: new ColumnItem(),
    approvedDate: new ColumnItem(),
    approver: new ColumnItem(),
    responsible: new ColumnItem(),
    hasAttachment: new ColumnItem(),
    id: new ColumnItem(),
    rowInfo: new ColumnItem(),
    internet: new ColumnItem(),
    readingReceipt: new ColumnItem(),
    readingReceiptDtmConfirmed: new ColumnItem()
};

if (internetPublishOption && !publishedVersion) {
    commonGridSetting.internet = new ColumnItem();
}

var commonColumnsDefinition = [];
var optionalColumnsDenifinition;
var layoutPlugin = new ngGridLayoutPlugin();

var charToPixelRatio = 9; //change this value if u change the font size
var autoColWidth = function (colDefs, rows) {
    var totalChars = {};
    var totalCharsLength = 0;
    for (var i = 0, n = rows.length; i < n; i++) {
        var tempTotalChars = {};
        for (var colName in rows[i]) {
            tempTotalChars[colName] = rows[i][colName].toString().length;
            if (i == 0 || tempTotalChars[colName] > totalChars[colName]) {
                totalChars[colName] = tempTotalChars[colName];
                totalCharsLength += tempTotalChars[colName];
            }
        }
    }

    for (var i = 0, n = colDefs.length; i < n; i++) {
        if (colDefs[i].field == commonGridColumns.attachment) {
            colDefs[i].width = "4%";
        } else {
            colDefs[i].width = (totalChars[colDefs[i].field] / totalCharsLength * 100) + "%";//(totalChars[colDefs[i].field] * charToPixelRatio) + "px";
        }
        
    };
    return colDefs;
}

var commonGridOptions = function (dataSource) {
    return {
        data: dataSource,
        plugins: [layoutPlugin],
        headerRowHeight: 40,
        rowHeight: 40,
        multiSelect: false,
        enableColumnResize: true,
        columnDefs: 'vm.commonGridColumnDefinition',
        rowTemplate: paths.WhatNewRowTemplate
    };
};

function getColumnsDefinition(gridSettingKey) {
    commonColumnsDefinition = [
        {
            field: commonGridColumns.rowInfo, displayName: '',
            minWidth: commonGridSetting.rowInfo.minWidth,
            width: commonGridSetting.rowInfo.width,
            cellTemplate: paths.DocumentInfoCellTemplate,
            visible: commonGridSetting.rowInfo.visible
        },
        {
            field: commonGridColumns.name, displayName: globalResources.CommonGridColumns.Title,
            width: commonGridSetting.title.width
        }, 
        {
            field: commonGridColumns.template, displayName: globalResources.CommonGridColumns.Type,
            width: commonGridSetting.documentType.width,
            visible: commonGridSetting.documentType.visible
        },
        {
            field: commonGridColumns.folderName, displayName: globalResources.CommonGridColumns.Chapter,
            width: commonGridSetting.chapter.width,
            cellTemplate: paths.FolderCellTemplate,
            visible: commonGridSetting.chapter.visible
        },
        {
            field: commonGridColumns.location, displayName: globalResources.CommonGridColumns.Location,
            width: commonGridSetting.location.width,
            cellTemplate: paths.LocationCellTemplate,
            visible: commonGridSetting.location.visible
        },
        {
            field: commonGridColumns.version, displayName: globalResources.CommonGridColumns.Version,
            minWidth: commonGridSetting.version.minWidth,
            width: commonGridSetting.version.width,
            visible: commonGridSetting.version.visible
        },
        {
            field: commonGridColumns.readCount, displayName: globalResources.CommonGridColumns.ReadCount,
            width: commonGridSetting.readCount.width,
            visible: commonGridSetting.readCount.visible
        },
        {
            field: commonGridColumns.documentId, displayName: globalResources.CommonGridColumns.DocumentId,
            minWidth: commonGridSetting.documentId.minWidth,
            width: commonGridSetting.documentId.width,
            visible: commonGridSetting.documentId.visible
        },
        {
            field: commonGridColumns.approvedDate, displayName: globalResources.CommonGridColumns.ApprovedDate,
            width: commonGridSetting.approvedDate.width,
            visible: commonGridSetting.approvedDate.visible
        },
        {
            field: commonGridColumns.approvedBy, displayName: globalResources.CommonGridColumns.Approver,
            width: commonGridSetting.approver.width,
            visible: commonGridSetting.approver.visible
        },
        {
            field: commonGridColumns.responsible, displayName: globalResources.CommonGridColumns.DocumentResponsible,
            width: commonGridSetting.responsible.width,
            visible: commonGridSetting.responsible.visible
        },
        {
            field: commonGridColumns.attachment, displayName: '',
            width: commonGridSetting.hasAttachment.width,
            cellTemplate: paths.DocumentAttachmentTemplate,
            visible: commonGridSetting.hasAttachment.visible
        },
        {
            field: commonGridColumns.readingReceipt, displayName: '',
            width: commonGridSetting.readingReceipt.width,
            visible: commonGridSetting.readingReceipt.visible
        },
        {
            field: commonGridColumns.readingReceiptDtmConfirmed, displayName: globalResources.CommonGridColumns.ReadingReceiptDtmCOnfirmedColumnHeader,
            width: commonGridSetting.readingReceiptDtmConfirmed.width,
            visible: commonGridSetting.readingReceiptDtmConfirmed.visible
        },
        {
            field: commonGridColumns.id, displayName: '',
            width: commonGridSetting.id.width,
            visible: false
        }
    ];

    optionalColumnsDenifinition = {
        version: commonGridSetting.version.visible,
        location: commonGridSetting.location.visible,
        documentType: commonGridSetting.documentType.visible,
        approvedDate: commonGridSetting.approvedDate.visible,
        approver: commonGridSetting.approver.visible,
        responsible: commonGridSetting.responsible.visible,
        chapter: commonGridSetting.chapter.visible,
        documentId: commonGridSetting.documentId.visible,
        hasAttachment: commonGridSetting.hasAttachment.visible,
        documentInfo: commonGridSetting.rowInfo.visible,
        readingReceipt: commonGridSetting.readingReceipt.visible,
        readingReceiptDtmConfirmed: commonGridSetting.readingReceiptDtmConfirmed.visible,
        readCount: commonGridSetting.readCount.visible
    };

    
    if (internetPublishOption && !publishedVersion) {
        // Add internet column after version column which has order 6
        commonColumnsDefinition.splice(6, 0, {
            field: commonGridColumns.internet,
            displayName: '',
            width: commonGridSetting.internet.width,
            visible: commonGridSetting.internet.visible
        });

        optionalColumnsDenifinition.internet = commonGridSetting.internet.visible;
    }

    if (gridSettingKey == gridSettingKeys.readingListVisibilitySettings) {
        commonColumnsDefinition.push({
            field: commonGridColumns.readingList, displayName: globalResources.ReadingList,
            width: commonGridSetting.readingList.width,
            visible: commonGridSetting.readingList.visible
        });
        commonColumnsDefinition.push({
            field: commonGridColumns.isConfirmed, displayName: globalResources.Confirmed,
            width: commonGridSetting.readingList.width,
            visible: commonGridSetting.readingList.visible
        });

        optionalColumnsDenifinition.readingList = commonGridSetting.readingList.visible;
        optionalColumnsDenifinition.isConfirmed = commonGridSetting.isConfirmed.visible;
    }
}


function getDefaultVisibleColumns(gridSettingKey) {
    commonGridSetting.title.visible = true;
    commonGridSetting.chapter.visible = true;
    commonGridSetting.documentId.visible = true;
    commonGridSetting.rowInfo.visible = true;

    if (internetPublishOption && !publishedVersion) {
        commonGridSetting.internet.visible = internetColumnVisible;
    }

    if (gridSettingKey == gridSettingKeys.readingListVisibilitySettings) {
        commonGridSetting.version.visible = true;
        commonGridSetting.documentId.visible = true;
        commonGridSetting.hasAttachment.visible = true;
        commonGridSetting.readingReceipt.visible = false;
        commonGridSetting.documentType.visible = false;
        commonGridSetting.approvedDate.visible = false;
        commonGridSetting.approver.visible = false;
        commonGridSetting.responsible.visible = false;
        commonGridSetting.location.visible = false;
        commonGridSetting.readingList.visible = true;
        commonGridSetting.readingReceiptDtmConfirmed.visible = false;
        commonGridSetting.isConfirmed.visible = true;
        commonGridSetting.readCount.visible = false;
    }

    getDefaultColumnWidth(gridSettingKey);
}

function clearColumnsVisibleSetting() {
    commonGridSetting.chapter.visible = false;
    commonGridSetting.documentId.visible = false;
    commonGridSetting.documentType.visible = false;
    commonGridSetting.readingList.visible = false;
    commonGridSetting.isConfirmed.visible = false;
    commonGridSetting.location.visible = false;
    commonGridSetting.version.visible = false;
    commonGridSetting.approvedDate.visible = false;
    commonGridSetting.approver.visible = false;
    commonGridSetting.responsible.visible = false;
    commonGridSetting.hasAttachment.visible = false;
    commonGridSetting.readingReceipt.visible = false;
    commonGridSetting.readingReceiptDtmConfirmed.visible = false;
    commonGridSetting.rowInfo.visible = false;
    commonGridSetting.readCount.visible = false;

    if (internetPublishOption && !publishedVersion) {
        commonGridSetting.internet.visible = false;
    }
}

function readVisibleColumnsFromLocalStorage(columnVisibleSettings) {
    clearColumnsVisibleSetting();
    var columnsSetting = columnVisibleSettings.split(',');
    for (var i = 0; i < columnsSetting.length; i++) {
        switch (columnsSetting[i]) {
            case 'chapter':
                commonGridSetting.chapter.visible = true;
                break;
            case 'documentId':
                commonGridSetting.documentId.visible = true;
                break;
            case 'documentType':
                commonGridSetting.documentType.visible = true;
                break;
            case 'readingList':
                commonGridSetting.readingList.visible = true;
                break;
            case 'isConfirmed':
                commonGridSetting.isConfirmed.visible = true;
                break;
            case 'location':
                commonGridSetting.location.visible = true;
                break;
            case 'version':
                commonGridSetting.version.visible = true;
                break;
            case 'approvedDate':
                commonGridSetting.approvedDate.visible = true;
                break;
            case 'approver':
                commonGridSetting.approver.visible = true;
                break;
            case 'responsible':
                commonGridSetting.responsible.visible = true;
                break;
            case 'hasAttachment':
                commonGridSetting.hasAttachment.visible = true;
                break;
            case 'readingReceipt':
                commonGridSetting.readingReceipt.visible = true;
                break;
            case 'readingReceiptDtmConfirmed':
                commonGridSetting.readingReceiptDtmConfirmed.visible = true;
                break;
            case 'documentInfo':
                commonGridSetting.rowInfo.visible = true;
                break;
            case 'internet':
                commonGridSetting.internet.visible = true;
            case 'readCount':
                commonGridSetting.readCount.visible = true;
                break;
        }
    }

    updateColumnWidth();
}

function getGridSetting(gridSettingKey) {
    if (typeof (Storage) != "undefined") { // Browser is supported local storage

        var existsInLocalStorage = false;
        var columnVisibleSettings = gridSettingKey ? localStorage.getItem(gridSettingKey) : localStorage.getItem(gridSettingKeys.readingListVisibilitySettings);
        if (columnVisibleSettings != undefined) {
            existsInLocalStorage = true;
        }

        if (existsInLocalStorage) {
            readVisibleColumnsFromLocalStorage(columnVisibleSettings);
        } else {
            getDefaultVisibleColumns(gridSettingKey);
        }
    } else {
        getDefaultVisibleColumns(gridSettingKey);
    }
}

function getDocumentColumnsForExporting(gridKey, modelType = E.GridViewModelType.Document) {
    var columns = [];
    getGridSetting(gridKey);
    columns.push(E.documentExportColumns.docUrl);

    if (commonGridSetting.internet.visible) {
        columns.push(E.documentExportColumns.isInternet);
    }

    switch (modelType) {
        case E.GridViewModelType.Document:
            columns.push(E.documentExportColumns.documentName);
            break;
        case E.GridViewModelType.Process:
            columns.push(E.documentExportColumns.processName);
            break;
        case E.GridViewModelType.InterconnectedProcess:
            columns.push(E.documentExportColumns.interconnectedProcessName);
            break;

        default:
            columns.push(E.documentExportColumns.documentName);
            break;
    }


    if (commonGridSetting.documentType.visible && (modelType == E.GridViewModelType.Process
        || modelType == E.GridViewModelType.Document || modelType == E.GridViewModelType.DocumentAndProcess)) {
        columns.push(E.documentExportColumns.documentType);
    }
    if (commonGridSetting.chapter.visible) {
        switch (modelType) {
            case E.GridViewModelType.Document:
                columns.push(E.documentExportColumns.chapter);
                break;
            case E.GridViewModelType.Process:
            case E.GridViewModelType.InterconnectedProcess:
                columns.push(E.documentExportColumns.processArea);
                break;

            default:
                columns.push(E.documentExportColumns.chapter);
                break;
        }
    }
    if (commonGridSetting.location.visible) {
        columns.push(E.documentExportColumns.location);
    }
    if (commonGridSetting.version.visible) {
        columns.push(E.documentExportColumns.version);
    }
    if (commonGridSetting.readCount.visible) {
        columns.push(E.documentExportColumns.readCount);
    }
    if (commonGridSetting.documentId.visible) {
        columns.push(E.documentExportColumns.documentId);
    }
    if (commonGridSetting.approvedDate.visible) {
        columns.push(E.documentExportColumns.approvedDate);
    }
    if (commonGridSetting.approver.visible) {
        columns.push(E.documentExportColumns.approver);
    }
    if (commonGridSetting.responsible.visible) {
        switch (modelType) {
            case E.GridViewModelType.Document:
                columns.push(E.documentExportColumns.documentResponsible);
                break;
            case E.GridViewModelType.Process:
            case E.GridViewModelType.InterconnectedProcess:
                columns.push(E.documentExportColumns.processResponsible);
                break;

            default:
                columns.push(E.documentExportColumns.documentResponsible);
                break;
        }
    }
    if (commonGridSetting.hasAttachment.visible) {
        columns.push(E.documentExportColumns.hasAttachment);
    }
    if (commonGridSetting.readingReceipt.visible) {
        columns.push(E.documentExportColumns.readingReceipt);
    }
    if (commonGridSetting.readingReceiptDtmConfirmed.visible) {
        columns.push(E.documentExportColumns.readingReceiptDtmConfirmed);
    }
    return columns;
}

function setGridSetting(gridSettingkey, gridColumns) {
    var columnSettings = '';

    if (gridColumns.documentType) {
        columnSettings += 'documentType,';
    }

    if (gridColumns.location) {
        columnSettings += 'location,';
    }

    if (gridSettingkey == gridSettingKeys.readingListVisibilitySettings) {
        if (gridColumns.readingList) {
            columnSettings += 'readingList,';
        }

        if (gridColumns.isConfirmed) {
            columnSettings += 'isConfirmed,';
        }
    }

    if (gridColumns.version) {
        columnSettings += 'version,';
    }

    if (gridColumns.readCount) {
        columnSettings += 'readCount,';
    }

    if (gridColumns.approvedDate) {
        columnSettings += 'approvedDate,';
    }

    if (gridColumns.approver) {
        columnSettings += 'approver,';
    }

    if (gridColumns.responsible) {
        columnSettings += 'responsible,';
    }

    if (gridColumns.chapter) {
        columnSettings += 'chapter,';
    }

    if (gridColumns.documentId) {
        columnSettings += 'documentId,';
    }

    if (gridColumns.hasAttachment) {
        columnSettings += 'hasAttachment,';
    }

    if (gridColumns.documentInfo) {
        columnSettings += 'documentInfo,';
    }

    if (gridColumns.readingReceipt) {
        columnSettings += 'readingReceipt,';
    }

    if (gridColumns.readingReceiptDtmConfirmed) {
        columnSettings += 'readingReceiptDtmConfirmed,';
    }

    if (gridColumns.internet) {
        columnSettings += 'internet';
    }

    //Remove last commna if any
    var lastSplitterIndex = columnSettings.lastIndexOf(',');
    if (lastSplitterIndex >= columnSettings.length - 1) {
        columnSettings = columnSettings.substring(0, lastSplitterIndex);
    }

    if (gridSettingkey) {
        localStorage.setItem(gridSettingkey, columnSettings);
    } else {
        localStorage.setItem(gridSettingKeys.commonVisibilitySettings, columnSettings);
    }

    getGridSetting(gridSettingkey);
}

function updateColumnWidth() {
    commonGridSetting.title.width = '20%';
    commonGridSetting.documentType.width = '12%';
    commonGridSetting.chapter.width = '14%';
    commonGridSetting.readingList.width = '0%';
    commonGridSetting.isConfirmed.width = '0%';
    commonGridSetting.location.width = '18%';
    commonGridSetting.version.width = 'auto';
    commonGridSetting.version.minWidth = '77px';
    commonGridSetting.readCount.width = 'auto';
    commonGridSetting.readCount.minWidth = '65px';
    commonGridSetting.documentId.width = 'auto'; 
    commonGridSetting.documentId.minWidth = '65px';
    commonGridSetting.approvedDate.width = 'auto';
    commonGridSetting.approvedDate.minWidth = '120px';
    commonGridSetting.approver.width = '9%';
    commonGridSetting.responsible.width = '10%';
    commonGridSetting.hasAttachment.width = '4%';
    commonGridSetting.readingReceipt.width = '4%';
    commonGridSetting.readingReceiptDtmConfirmed.width = 'auto';
    commonGridSetting.readingReceiptDtmConfirmed.minWidth = '120px';
    commonGridSetting.id.width = '0%';
    commonGridSetting.rowInfo.width = 'auto'; 
    commonGridSetting.rowInfo.minWidth = '24px';

    if (internetPublishOption && !publishedVersion) {
        commonGridSetting.internet.width = '24px';
    }
}

function getDefaultColumnWidth(gridSettingKey) {
    commonGridSetting.title.width = '20%';
    commonGridSetting.documentType.width = '12%';
    commonGridSetting.chapter.width = '14%';
    commonGridSetting.location.width = '18%';
    commonGridSetting.version.width = 'auto';
    commonGridSetting.version.minWidth = '77px';
    commonGridSetting.version.width = 'auto';
    commonGridSetting.version.minWidth = '65px';
    commonGridSetting.documentId.width = '65px';
    commonGridSetting.approvedDate.width = 'auto';
    commonGridSetting.approvedDate.minWidth = '120px';
    commonGridSetting.approver.width = '9%';
    commonGridSetting.responsible.width = '10%';
    commonGridSetting.hasAttachment.width = '4%';
    commonGridSetting.readingReceipt.width = '4%';
    commonGridSetting.readingReceiptDtmConfirmed.width = 'auto';
    commonGridSetting.readingReceiptDtmConfirmed.minWidth = '120px';
    commonGridSetting.id.width = '0%';
    commonGridSetting.rowInfo.width = 'auto'; 
    commonGridSetting.rowInfo.minWidth = '24px';

    if (internetPublishOption && !publishedVersion) {
        commonGridSetting.internet.width = '24px';
    }

    if (gridSettingKey == gridSettingKeys.readingListVisibilitySettings) {
        commonGridSetting.readingList.width = '0%';
        commonGridSetting.isConfirmed.width = '0%';
    }
}

function getBooleanValue(val) {
    return val === 'true';
}

function getArray(obj) {
    var array = [];
    for (var i in obj) {
        array.push(obj[i]);
    }
    return array;
}

function groupBy(list, fn) {
    var groups = {};
    for (var i = 0; i < list.length; i++) {
        var group = fn(list[i])[0];
        if (group in groups) {
            groups[group].value.data.push(list[i]);
        } else {
            groups[group] = { key: '', value: [] };
            groups[group].key = group;
            groups[group].value = { data: [], gridOption: {} };
            groups[group].value.data.push(list[i]);
        }
    }
    return getArray(groups);
}

String.format = function () {
    var result = arguments[0];
    for (var i = 0; i < arguments.length - 1; i++) {
        var reg = new RegExp("\\{" + i + "\\}", "gm");
        result = result.replace(reg, arguments[i + 1]);
    }
    return result;
}

function FormattedDateDMYYYY(date, delimiter) {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    return day + delimiter + month + delimiter + year;
}

function ngGridLayoutPlugin() {
    var self = this;
    this.grid = null;
    this.scope = null;
    this.init = function (scope, grid, services) {
        self.domUtilityService = services.DomUtilityService;
        self.grid = grid;
        self.scope = scope;
    };

    this.updateGridLayout = function () {
        if (self.scope == null) {
            return;
        }
        if (!self.scope.$$phase) {
            self.scope.$apply(function () {
                self.domUtilityService.RebuildGrid(self.scope, self.grid);
            });
        }
        else {
            // $digest or $apply already in progress
            self.domUtilityService.RebuildGrid(self.scope, self.grid);
        }
    };
}

function msieversion() {
    var ua = window.navigator.userAgent
    var msie = ua.indexOf("MSIE ")

    if (msie > 0)      // If Internet Explorer, return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else if (!!navigator.userAgent.match(/Trident.*rv\:11\./))                 // If another browser, return 0
        return 11;
    else
        return 0;
}

function detectIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}

function isSafari() {
    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    return (isSafari == null ? false : isSafari);
}

var NewsGridConfig = {
    pageSize: 10,
    maxDisplayPage: 3
};

function splitDateString(dateString) {
    if (dateString.indexOf('.') > -1) {
        return dateString.split('.');
    } else if (dateString.indexOf('/') > -1) {
        return dateString.split('/');
    } else if (dateString.indexOf('-') > -1) {
        return dateString.split('-');
    }
}

var Utils = {
    ToDate: function (dateString) { //Norwegian format: dd.MM.yyyy
        if (dateString == "" || dateString == null) {
            return new Date('01-01-1900');
        }
        else {
            var dateParts = splitDateString(dateString);
            if (dateString.indexOf('/') > -1) {
                return new Date(dateParts[2], dateParts[0] - 1, dateParts[1], 0, 0, 0, 0); //year, month, day, hours, minutes, seconds, milliseconds
            }

            return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], 0, 0, 0, 0); //year, month, day, hours, minutes, seconds, milliseconds
        }
    },
    ToDateTime: function (dateTimeString) {
        if (dateTimeString == "" || dateTimeString == null) {
            return new Date('01-01-1900');
        }
        else {
            var dateTimeParts = dateTimeString.split(' ');
            var dateParts = splitDateString(dateTimeParts[0]);
            var timeParts = dateTimeParts[1].split(':');
            if (dateString.indexOf('/') > -1) {
                return new Date(dateParts[2], dateParts[0] - 1, dateParts[1], timeParts[0], timeParts[1], 0, 0); //year, month, day, hours, minutes, seconds, milliseconds
            }

            return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], 0, 0); //year, month, day, hours, minutes, seconds, milliseconds
        }
    }
};

var dialogTypes = {
    OK: 1,
    OK_CANCEL: 2,
    YES_NO: 3
};

var dialogResults = {
    CONFIRM: 1,
    CANCEL: 2
};

var RESPONSE_MESSAGE = {
    recommended: 1,
    notRecommended: 2,
    neutral: 3
};

void function $getLines($) {
    function countLines($element) {
        var lines = 0;
        var greatestOffset = void 0;

        $element.find('character').each(function () {
            if (!greatestOffset || this.offsetTop > greatestOffset) {
                greatestOffset = this.offsetTop;
                ++lines;
            }
        });

        return lines;
    }

    $.fn.getLines = function $getLines() {
        var lines = 0;
        var clean = this;
        var dirty = this.clone();

        (function wrapCharacters(fragment) {
            var parent = fragment;

            $(fragment).contents().each(function () {
                if (this.nodeType === Node.ELEMENT_NODE) {
                    wrapCharacters(this);
                }
                else if (this.nodeType === Node.TEXT_NODE) {
                    void function replaceNode(text) {
                        var characters = document.createDocumentFragment();

                        text.nodeValue.replace(/[\s\S]/gm, function wrapCharacter(character) {
                            characters.appendChild($('<character>' + character + '</>')[0]);
                        });

                        parent.replaceChild(characters, text);
                    }(this);
                }
            });
        }(dirty[0]));

        clean.replaceWith(dirty);

        lines = countLines(dirty);

        dirty.replaceWith(clean);

        return lines;
    };
}(jQuery);

function getElementForTooltips(label, value) {
	var fisrtOfElement = "    <div class='table-row'><span class='tooltip-element'><b>";
	var centerOfElement = "</b></span> <span class='table-cell'>";
	var lastOfElement = "</span></div>";

	return fisrtOfElement + label + centerOfElement + value + lastOfElement;
}


function generateRelatedDocumentTooltip(row) {
    var result = "<div class='table-css'>";
	result += getElementForTooltips(globalResources.LinkedVirtually, row.virtual ? globalResources.Yes : globalResources.No);
	result += getElementForTooltips(globalResources.CommonGridColumns.Title, row.name);
	result += getElementForTooltips(globalResources.CommonGridColumns.Type, row.template);
	result += getElementForTooltips(globalResources.CommonGridColumns.Chapter, row.folderName);
	result += getElementForTooltips(globalResources.CommonGridColumns.Location, row.location);
	result += getElementForTooltips(globalResources.CommonGridColumns.Version, row.version);
	result += getElementForTooltips(globalResources.CommonGridColumns.DocumentId, row.documentId);
    result += getElementForTooltips(globalResources.CommonGridColumns.ApprovedDate, row.approvedDate);
    if (!publishedVersion) {
        result += getElementForTooltips(globalResources.CommonGridColumns.Approver, row.approvedBy);
        result += getElementForTooltips(globalResources.CommonGridColumns.Responsible, row.responsible);
    }
    result += "</div>";

    return result;
}

function generateRelateProcessTooltip(row) {
    var result = "<div class='table-css'>";
    result += getElementForTooltips(globalResources.CommonGridColumns.Title, row.name);
    result += getElementForTooltips(globalResources.CommonGridColumns.Status, row.approvalStatus);
    result += getElementForTooltips(globalResources.CommonGridColumns.ProcessArea, row.processAreaName);
    result += getElementForTooltips(globalResources.CommonGridColumns.Version, row.version);
    result += getElementForTooltips(globalResources.CommonGridColumns.Process, row.processNumber);
    result += getElementForTooltips(globalResources.CommonGridColumns.ApprovedDate, row.approvedDate);
    if (!publishedVersion) {
        result += getElementForTooltips(globalResources.CommonGridColumns.Approver, row.approvedBy);
        result += getElementForTooltips(globalResources.CommonGridColumns.Responsible, row.responsible);
    }
    result += "</div>";

    return result;
}


function createTooltipsRelatedDocument(data) {
    if (data.relatedDocuments != null && data.relatedDocuments.length > 0) {
        data.relatedDocuments.forEach(function (item) {
            item.htmlTooltips = generateRelatedDocumentTooltip(item);
        });
    }
    if (data.relatedProcess != null && data.relatedProcess.length > 0) {
        data.relatedProcess.forEach(function (item) {
            item.htmlTooltips = generateRelateProcessTooltip(item);
        });
    }

    if (data.fieldContents != null) {
        data.fieldContents.forEach(function (fieldContent) {
            if (fieldContent.relatedDocuments != null && fieldContent.relatedDocuments.length > 0) {
                fieldContent.relatedDocuments.forEach(function (item) {
                    item.htmlTooltips = generateRelatedDocumentTooltip(item);
                });
            }
            if (fieldContent.relatedProcess != null && fieldContent.relatedProcess.length > 0) {
                fieldContent.relatedProcess.forEach(function (item) {
                    item.htmlTooltips = generateRelateProcessTooltip(item);
                });
            }
        });
    }
}

var LANGUAGECULTURE = 'languageCulture';

var LANGUAGES = {
    NorwegianBokmal: 'no',
	NorwegianNynorsk: 'nn',
    English: 'en'
};

/*Open dialog add members, roleId use for editrole view*/
function openAddMembersDialog(modal, existedMember, titlePage, roleId, excludedQuitDepartmentId, folderId, isHearing) {
    if (excludedQuitDepartmentId == null)
        excludedQuitDepartmentId = false;

    var modalInstance = modal.open({
        templateUrl: '/app/components/document/addMembers.html',
        controller: 'AddMembersController as vm',
        size: 'lg',
        resolve: {
            existedEmployees: function () {
                return existedMember;
            },
            titlePage: function () {
                return titlePage;
            },
            roleId: function () {
                return roleId;
            },
            excludedQuitDepartmentId: function () {
                return excludedQuitDepartmentId;
            },
            folderId: function () {
                return folderId;
            },
            isHearing: function () {
                return isHearing;
            }
        }
    });

    return modalInstance;
};

var gridUtilities = {
    lookupData: function (data, rowCollection, originalCollection, infiniteScrollLoadsize, total, currentRowIndex) {
        var newTotal = data != null ? data.length : 0;
        if (infiniteScrollLoadsize == 0) {
            rowCollection = data;
            originalCollection = angular.copy(rowCollection);
        } else {
            if ((rowCollection == null || rowCollection.length == 0) || total != newTotal) {
                total = newTotal;
                currentRowIndex = 0;
                var response = gridUtilities.getAPageItem(data, infiniteScrollLoadsize, currentRowIndex, total);
                rowCollection = response.data;
                currentRowIndex = response.currentIndex;
                originalCollection = angular.copy(rowCollection);
            }
        }

        return { total: total, currentIndex: currentRowIndex, data: rowCollection };
    },
    getAPageItem: function (items, infiniteScrollLoadsize, currentRowIndex, total) {
        var data = [];
        var startIndex = currentRowIndex;
        var endIndex = startIndex + infiniteScrollLoadsize;
        for (var i = startIndex; i < endIndex; i++) {
            if (currentRowIndex < total) {
                data.push(items[i]);
                currentRowIndex += 1;
            } else {
                break;
            }
        }
        return { data: data, currentIndex: currentRowIndex };
    }
};



// Production steps of ECMA-262, Edition 5, 15.4.4.17
// Reference: https://es5.github.io/#x15.4.4.17
if (!Array.prototype.some) {
    Array.prototype.some = function (fun, thisArg) {
        'use strict';

        if (this == null) {
            throw new TypeError('Array.prototype.some called on null or undefined');
        }

        if (typeof fun !== 'function') {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(thisArg, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}


function getIconsWithReadPermission(nodeInfo, notTextWhite) {
    var iconFolder = '';
    if (nodeInfo.expanded) {
        iconFolder = nodeInfo.onlyRead ? "far fa-folder-open" : "fa fa-folder-open";
    }
    else {
        iconFolder = nodeInfo.onlyRead ? "fal fa-folder" : "fa fa-folder";
    }
    if (nodeInfo.type == null)
        return 'f-normal ' + iconFolder;
    switch (nodeInfo.type.toString()) {
        case E.nodeTypes.RegionalFolder:
            return 'f-regional ' + iconFolder;
        case E.nodeTypes.Folder:
            return 'f-normal ' + iconFolder;
        case E.nodeTypes.TopFolder:
            return 'f-enterprise ' + iconFolder;
        case E.nodeTypes.DepartmentFolder:
            return 'f-department ' + iconFolder;
        case E.nodeTypes.Document:
            return 'typcn typcn-document-text' + (notTextWhite ? '' : ' text-white');
        case E.nodeTypes.LinkDocument:
            return 'typcn typcn-link' + (notTextWhite ? '' : ' text-white');
        case E.nodeTypes.FileDocument:
            return 'typcn typcn-attachment' + (notTextWhite ? '' : ' text-white');
        case E.nodeTypes.ShortcutDocument:
            return 'virtual-document';
        default:
            return 'f-normal ' + iconFolder;
    }
}